import React from 'react';
import { Link } from 'react-router-dom';

import useGlobalState from '../GlobalStateContext';
import { OptionalRolesOrPermissions } from '../helpers/Permissions';

type Props = {
    url: string;
    value: unknown;
    target?: string;
} & OptionalRolesOrPermissions;

export default function ProtectedLink({ url, value, roles = [], permissions = [], target = '' }: Props) {
    const { loggedAdmin } = useGlobalState();

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <Link target={target} to={url}>
            {value}
        </Link>
    ) : (
        <>{value ?? '\u2014'}</>
    );
}
